// extracted by mini-css-extract-plugin
export default {"text":"FuTBLnuVzWCUzSD8pxgr","row":"VnF4BrUYF4Sr7tRndMfw","container":"VjRozqmSl0VifpRhwGTM"};